import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import GoldReport from './components/GoldReport';

function App() {
    return (
        <BrowserRouter>
            <div className="min-h-screen bg-[#234363]">
                <Routes>
                    <Route path="/:slug" element={<GoldReport />} />
                    <Route path="/" element={<Navigate to="/invalid" replace />} />
                </Routes>
            </div>
        </BrowserRouter>
    );
}

export default App;